export const artDirectionInformationArray = [
  {
    title: "America at 300: Imagining the next half-century of change",
    description: "",
    link: "https://www.washingtonpost.com/science/2026/07/01/america-300-imagining-next-half-century-change/",
    illustrator: [
      {
        name: "Illustrations by Ibrahim Rayintakath",
        portfolio: "https://rayintakath.com/",
      },
    ],

    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/artdirection/america2076.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/america2076-spot1.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/america2076-spot2.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/america2076-spot3.jpg",
      },
    ],
  },
  {
    title: "The major Supreme Court decisions in 2025",
    description: "",
    awards: "",
    link: "https://www.washingtonpost.com/politics/interactive/2025/supreme-court-cases-decisions/",
    illustrator: [
      {
        name: "Illustrations by Miriam Martincic",
        portfolio: "https://laurenmartinnyc.com/",
      },
    ],

    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/artdirection/scotus-tracker.jpg",
      },
    ],
  },
  {
    title: "The fugitive heiress next door",
    description: "",
    link: "https://www.washingtonpost.com/lifestyle/interactive/2023/margarida-bonetti-brazil-podcast-slavery/",
    illustrator: [
      {
        name: "Illustrations by Hokyoung Kim",
        portfolio: "https://www.hokyoungkim.com/",
      },
    ],

    illustrations: [
      {
        type: "video",
        size: "main",
        source: "/projects/artdirection/brazil-video.mp4",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/brazil-1.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/brazil-2.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/brazil-3.jpg",
      },
    ],
  },
  {
    title:
      "Why the nation’s founding document is marred by stains, a mysterious handprint",
    description: "",
    awards: "",
    link: "https://www.washingtonpost.com/politics/2026/06/28/why-stains-creases-handprint-mar-declaration-independence/",
    illustrator: [
      {
        name: "Illustration by Leland Foster",
        portfolio: "https://www.lelandkfoster.com/",
      },
    ],

    illustrations: [
      {
        type: "video",
        size: "main",
        source: "/projects/artdirection/declaration.mp4",
      },
    ],
  },
  {
    title:
      "After pandemic closures, kids are still behind. Can you do their math?",
    description: "",
    link: "https://www.washingtonpost.com/education/interactive/2024/dc-school-math-quiz/",
    illustrator: [
      {
        name: "Illustrations by Sean Dong",
        portfolio: "https://www.hokyoungkim.com/",
      },
    ],

    illustrations: [
      {
        type: "video",
        size: "main",
        source: "/projects/artdirection/mathquiz-1.mp4",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/mathquiz-2.png",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/mathquiz-3.png",
      },
    ],
  },
  {
    title:
      "Pretend you’re in Congress and we’ll give you a committee assignment",
    description: "",
    link: "https://www.washingtonpost.com/politics/interactive/2023/house-committee-assignment-process-quiz/",
    illustrator: [
      {
        name: "Illustrations by Jordan Awan",
        portfolio: "https://jordanawan.com/",
      },
    ],

    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/artdirection/house-committee-quiz.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/house-committee-quiz-1.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/house-committee-quiz-2.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/house-committee-quiz-3.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/house-committee-quiz-4.jpg",
      },
    ],
  },
  {
    title: "Navigating Medicare",
    description: "",
    link: "https://www.washingtonpost.com/politics/interactive/2023/house-committee-assignment-process-quiz/",
    illustrator: [
      {
        name: "Illustrations by Till Lauer",
        portfolio: "https://jordanawan.com/",
      },
    ],

    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/artdirection/medicare-1.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/medicare-2.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/medicare-3.jpg",
      },
      {
        type: "image",
        size: "spot",
        source: "/projects/artdirection/medicare-4.jpg",
      },
    ],
  },
  {
    title: "Flying with kids? Parents’ best tips for a meltdown-free ride.",
    description: "",
    link: "https://www.washingtonpost.com/travel/tips/flying-kids-tips/",
    illustrator: [
      {
        name: "Illustration by Scott Balmer",
        portfolio: "https://scottbalmer.co.uk/",
      },
    ],
    stories: [
      {
        headline: "",
        link: "",
      },
    ],
    illustrations: [
      {
        type: "image",
        size: "main",
        source: "/projects/artdirection/babypassenger.jpg",
      },
    ],
  },
];
